import { render } from "./banner.modules.vue?vue&type=template&id=066b6b9b&ts=true"
import script from "./banner.modules.vue?vue&type=script&lang=ts"
export * from "./banner.modules.vue?vue&type=script&lang=ts"

import exportComponent from "/home/seb/_git-wsl/inv-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__